import { render } from "./SetProduct.vue?vue&type=template&id=08dde1cf&scoped=true"
import script from "./SetProduct.vue?vue&type=script&lang=js"
export * from "./SetProduct.vue?vue&type=script&lang=js"

import "./SetProduct.vue?vue&type=style&index=0&id=08dde1cf&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dde1cf"]])

export default __exports__